import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/recommendation-management/editors-pick')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
